<template>
  <div class="edit-giftcard">
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"
          ><strong>{{ $t("giftcard") }}</strong></mdb-card-title
        >
      </mdb-card-header>
      <mdb-card-body>
        <ChainSelection v-on:member="member" :content="giftcard" />
        <mdb-row>
          <mdb-col md="12">
            <GoogleMap
              v-on:marker-moved="markerMoved"
              :marker="computedMarker"
              class="google-map"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-5">
          <mdb-col md="12">
            <p class="h5">{{ $t("giftcard_content") }}</p>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-input
              v-model="localGiftcard.title"
              v-if="this.loadReady === true"
              type="text"
              icon="quote-right"
              :label="$t('giftcard_title')"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-input
              v-model="localGiftcard.description"
              v-if="this.loadReady === true"
              type="textarea"
              icon="quote-left"
              :label="$t('giftcard_description')"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <Categories
              v-on:categories="selectedCategories"
              v-if="this.loadReady === true"
              :multipleSelected="false"
              :category-id="categoryId"
            />
          </mdb-col>
          <mdb-col>
            <mdb-input
              :label="$t('manage_access_code_modal_input_end')"
              type="date"
              v-model="localGiftcard.validuntil"
            />
          </mdb-col>
          <mdb-col>
            <mdb-input
              v-model="chainGiftcard"
              type="checkbox"
              id="checkBoxChainGiftcard"
              class="mt-3"
              :label="$t('giftcard_chaingiftcard')"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-input
              v-model="localGiftcard.defaultvalue"
              v-if="this.loadReady === true"
              type="number"
              icon="quote-right"
              :min="1"
              :label="$t('giftcard_value')"
            />
          </mdb-col>
          <mdb-col>
            <mdb-input
              v-model="localGiftcard.valuestep"
              v-if="this.loadReady === true"
              type="number"
              icon="quote-right"
              :min="1"
              :label="$t('giftcard_valuestep')"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <hr />
            <p class="h6">{{ $t("giftcard_image") }}</p>
            <ImageInput
              v-if="this.loadReady === true"
              :image-src="getImageSrc()"
              :imageWidth="400"
              :buttonName="$t('advertisement_add_image')"
              v-on:general-image="giftcardImage"
            />
            <hr />
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-4">
          <mdb-col md="12" class="mt-4">
            <mdb-btn
              @click="saveGiftcard"
              color="indigo"
              class="white-text"
              icon="paper-plane"
              style="width: 200px"
              >{{ $t("save") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle
} from "mdbvue";
import ChainSelection from "../components/ChainSelection.vue";
import GoogleMap from "./GoogleMap.vue";
import Categories from "./Categories.vue";
import ImageInput from "./ImageInput.vue";
export default {
  name: "EditGiftcard",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    Categories,
    ImageInput,
    ChainSelection,
    GoogleMap
  },
  props: {
    defaultMarker: Object
  },
  computed: {
    computedMarker() {
      return this.marker;
    }
  },
  methods: {
    giftcardImage(val) {
      this.localGiftcard.image = val;
      this.localGiftcard.imageurl = "";
    },
    loadGiftcard() {
      if (!this.isNewGiftcard()) {
        this.getGiftcard(this.getGiftcardId());
      } else {
        this.loadReady = true;
      }
    },
    setChainId() {
      this.localGiftcard.chainid !== 0
        ? (this.chainGiftcard = true)
        : (this.chainGiftcard = false);
    },
    getChainId() {
      return this.chainGiftcard === true ? this.localGiftcard.chainid : 0;
    },
    getGiftcardId() {
      try {
        return parseInt(this.$route.path.match(/(\d+)/)[0]);
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    isNewGiftcard() {
      return this.getGiftcardId() === 0;
    },
    dateTimeChanged(val) {
      if (this.dateTime.localeCompare(val) !== 0) {
        this.dateTime = val;
      }
    },
    createMarker() {
      var marker = {
        name: "Position",
        position: {
          lat: this.marker.position.lat,
          lng: this.marker.position.lng
        },
        radius: this.marker.radius
      };
      this.marker = marker;
    },
    markerMoved(val) {
      this.marker.position.lat = val.getPosition().lat();
      this.marker.position.lng = val.getPosition().lng();
      this.createMarker();
      console.log(val);
    },
    selectedCategories(value, text) {
      this.categories = value;
      console.log(value, text);
    },
    member(member, chainId) {
      this.retailer = member;
      this.localGiftcard.chainid = chainId;
      this.marker.position.lat = member.lat;
      this.marker.position.lng = member.lng;
      this.createMarker();
    },
    getImageSrc() {
      if (this.localGiftcard.imageurl === "")
        return "https://mdbootstrap.com/img/Photos/Others/placeholder.jpg";
      else return this.localGiftcard.imageurl;
    },
    fillLocalGiftcard(val) {
      this.localGiftcard.title = val.title;
      this.localGiftcard.description = val.description;
      this.localGiftcard.chainid = val.chainid;
      this.localGiftcard.validuntil = val.validuntil.split(" ")[0];
      this.localGiftcard.imageurl = val.image;
      this.localGiftcard.retailerid = val.retailerid;
      this.localGiftcard.defaultvalue = val.defaultvalue;
      this.localGiftcard.valuestep = val.valuestep;
      this.giftcard = new Object();
      this.giftcard.retailerid = val.retailerid;
      this.giftcard.chainid = val.chainid;
      this.setChainId();

      /*this.categories = val.categories;
      (this.marker.position.lat = val.latitude),
        (this.marker.position.lng = val.longitude);
      this.createMarker();*/
      console.log(val);
    },
    getGiftcard() {
      this.$notify.info({
        message: this.$t("loading_giftcard"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium
      });
      this.$http
        .get(
          this.readgiftcardpath +
            this.$store.getters.getToken
        )
        .then(response => {
          if (response.status == 200) {
            this.fillLocalGiftcard(response.data.giftcards[0]);
            this.benefits = response.data.benefits;
            this.loadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch(error => {
          return error;
        });
    },
    saveGiftcard() {
      try {
        this.postData = {
          sessionid: this.$store.getters.getToken,
          image: this.localGiftcard.image,
          imageurl: this.localGiftcard.imageurl,
          description: this.localGiftcard.description,
          title: this.localGiftcard.title,
          validuntil: this.localGiftcard.validuntil,
          categories: this.categories,
          retailerid: this.retailer.id,
          chainid: this.getChainId(),
          defaultvalue: this.localGiftcard.defaultvalue,
          valuestep: this.localGiftcard.valuestep,
          type: "INSTORE",
          usemode: "MONEY"
        };
        this.$http
          .post(this.creategiftcardpath, JSON.stringify(this.postData))
          .then(response => {
            if (response.status == 200) {
              this.$notify.success({
                message: this.$t("adding_giftcard_success"),
                position: "top right",
                timeOut: this.$store.state.notifytimeoutshort
              });
            }
            this.$emit("modal-ok");
          })
          .catch(error => {
            this.$notify.error({
              message: this.$t("adding_giftcard_not_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium
            });
            this.$emit("modal-ok");
            console.log(error);
          })
          .finally(() => (this.loading = false));
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    this.loadGiftcard();
  },
  data() {
    return {
      creategiftcardpath: "/2.0/newbe/giftcards",
      updategiftcardpath: `/2.0/newbe/giftcards/${this.getGiftcardId()}`,
      readgiftcardpath: `/2.0/newbe/giftcards/${this.getGiftcardId()}?sessionid=`,
      giftcard: null,
      title: "",
      description: "",
      dateTime: "",
      formattedDateTime: "",
      categories: null,
      categoryId: 0,
      chainGiftcard: false,
      marker: this.defaultMarker,
      loadReady: false,
      validuntil: "",
      componentKey: 0,
      localGiftcard: {
        title: "",
        description: "",
        defaultvalue: 0,
        chainid: 0,
        validuntil: "",
        image: "",
        imageurl: ""
      }
    };
  }
};
</script>

<style></style>
